import React from "react";
import { Button, Card, Content, Dropdown, Image, Media } from "react-bulma-components";
import { Icon, IconText } from "../common/Icon";
import { UilEllipsisV, UilLink, UilLinkAdd, UilTrash } from "@iconscout/react-unicons";
import ProjectSection from "./ProjectSection";
import { MODAL_ADD_INSPIRATION } from "./ProjectConstants";

export default function ProjectInspirations({ inspirations, onTriggerDelete, onTriggerModal, project }) {
    const actions = (
        <>
            <Button size="small" colorVariant="light" onClick={ () => onTriggerModal(MODAL_ADD_INSPIRATION) }>
                <IconText icon={ UilLinkAdd } size={ 12 }>
                    Add inspiration
                </IconText>
            </Button>
        </>
    );

    const items = inspirations.map(item => {
        const onClickDropdownItem = async (value) => {
            if (value === 'delete') {
                await onTriggerDelete(`/api/projects/${ project }/inspiration/${ item.id }`);
            }
        }

        return (
            // TODO: The link hitbox is a bit weird on this... there's a gap at the top and bottom, and around the image
            <Card key={ item.id }>
                <Card.Content>
                    <Media>
                        <Media.Item align="left">
                            <a href={ item.url } target="_blank" rel="noreferrer">
                                {/* TODO: Fix image sizes. Maybe return multiple sizes? */ }
                                <Image size={ 48 } src={ item.image }/>
                            </a>
                        </Media.Item>

                        <Media.Item align="center" display="flex">
                            <div className="is-flex-grow-1">
                                <a href={ item.url } target="_blank" rel="noreferrer">
                                    <p className="is-6">
                                        { item.title }
                                    </p>

                                    <Content>
                                        <IconText icon={ UilLink } renderAs="a">
                                        <span className="has-text-grey is-size-7">
                                            { item.url }
                                        </span>
                                        </IconText>
                                    </Content>
                                </a>
                            </div>
                        </Media.Item>

                        <Media.Item align="right">
                            <div className="ml-2 has-text-right">
                                <Dropdown onChange={ onClickDropdownItem } color="ghost" hoverable right
                                          label={ <Icon icon={ UilEllipsisV }/> }>
                                    <Dropdown.Item renderAs="a" value="delete">
                                        <IconText className="has-text-danger" icon={ UilTrash }>
                                            Delete
                                        </IconText>
                                    </Dropdown.Item>
                                </Dropdown>
                            </div>
                        </Media.Item>
                    </Media>
                </Card.Content>
            </Card>
        );
    });


    return (
        <ProjectSection title="Inspiration" itemCount={ inspirations.length } noItemsText="No inspiration yet!"
                        actions={ actions }>
            { items }
        </ProjectSection>
    )
}